(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
 /* ==========================================
   MASAÜSTÜ MENÜ - HOVER İLE AÇILMA
   Alt menüye geçişte kapanmayı engeller
   ========================================== */

if (window.matchMedia('(min-width: 990px)').matches) {
  const headerMenus = document.querySelectorAll(
    'header-menu details, .header__inline-menu details'
  );

  headerMenus.forEach((details) => {
    const summary = details.querySelector(':scope > summary');

    if (!summary) return;

    let closeTimer;

    const openMenu = () => {
      clearTimeout(closeTimer);

      /* Diğer açık menüleri kapat */
      headerMenus.forEach((otherDetails) => {
        if (otherDetails !== details) {
          clearTimeout(otherDetails._closeTimer);

          otherDetails.removeAttribute('open');

          const otherSummary =
            otherDetails.querySelector(':scope > summary');

          if (otherSummary) {
            otherSummary.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        }
      });

      details.setAttribute('open', '');

      summary.setAttribute(
        'aria-expanded',
        'true'
      );
    };

    const closeMenu = () => {
      clearTimeout(closeTimer);

      closeTimer = setTimeout(() => {
        details.removeAttribute('open');

        summary.setAttribute(
          'aria-expanded',
          'false'
        );
      }, 350);

      details._closeTimer = closeTimer;
    };

    /* Menü başlığının üzerine gelince aç */
    details.addEventListener(
      'mouseenter',
      openMenu
    );

    /* Menü alanından çıkınca biraz bekle */
    details.addEventListener(
      'mouseleave',
      closeMenu
    );

    /* Mega menü alanına girilirse kapanmayı iptal et */
    const submenu = details.querySelector(
      '.mega-menu__content, .header__submenu'
    );

    if (submenu) {
      submenu.addEventListener(
        'mouseenter',
        () => {
          clearTimeout(closeTimer);
        }
      );

      submenu.addEventListener(
        'mouseleave',
        closeMenu
      );
    }
  });
}

/* ==========================================
   /MASAÜSTÜ MENÜ - HOVER İLE AÇILMA
   ========================================== */

  } catch(e) { console.error(e); }
})();
})();
